import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {RightBarSection} from '../../section';
import {IWifiScanHistoryController} from './WifiScanHistoryController';
import {WifiScanHistory} from '../../../wifi-scan-history/WifiScanHistory';
import Translate from '../../../translate/Translate';
import './WifiScanHistorySection.scss';

interface WifiScanHistorySectionProps {
    ctrl: IWifiScanHistoryController;
}

@observer
export class WifiScanHistorySection extends TechseeBaseComponent<WifiScanHistorySectionProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (!ctrl.shouldShow) {
            return <></>;
        }

        return (
            <RightBarSection
                isOpen={ctrl.sectionOpen}
                onToggle={ctrl.toggleSection}
                useNewInterface={ctrl.useNewInterface}
                dir={ctrl.dir}
                className='history-list-group'
                title={
                    <>
                        <Translate text='MAIN.VIEW.WIFI_SCANS' />
                    </>
                }>
                {ctrl.isEmpty ? (
                    <div className='panel-empty'>
                        <Translate text='MAIN.VIEW.NO_WIFI_SCAN_HISTORY_FOR_CUSTOMER' />
                    </div>
                ) : (
                    <>
                        <WifiScanHistory
                            onClickWifiScanHistoryButton={ctrl.onClickWifiScanHistoryButton}
                            wifiScanHistoryData={ctrl.wifiScanHistoryData}
                            wifiScanTranslation={ctrl.wifiScanTranslation}
                        />
                    </>
                )}
            </RightBarSection>
        );
    }
}
